/* @flow weak */
import cx from 'classnames';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React from 'react';

import './styles/ManagerItemCard.scss';

const ManagerItemCard = ({ className, children }) =>
  <div className={cx('ManagerItemCard', className)}>
    {children}
  </div>;

export const ManagerItemPlaceholderCard = ({ className }) =>
  <ManagerItemCard className={cx('ManagerItemPlaceholderCard', className)}>
    <LoadingIndicator />
  </ManagerItemCard>;

export default ManagerItemCard;



// WEBPACK FOOTER //
// ./src/payments/components/ManagerItemCard.jsx